<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Consultar cheques
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Finanzas</span>
            <span> /</span>
            <span>Consultar cheques</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
    <form [formGroup]='formHeader'>
        <div class="card-body justify-content-between">
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-select label="Tipo de cheque" [options]="optionsTipoCheque" [multiple]="true"
                            placeholder="Tipo de cheque" [filterEnabled]="true" formControlName="tiposCheque">
                        </mdb-select>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                                  formHeader.get('fechaDesde').invalid &&
                                  (formHeader.get('fechaDesde').dirty ||
                                  formHeader.get('fechaDesde').touched)
                              ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha desde
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                            formControlName="fechaHasta">
                        </mdb-date-picker>
                        <div *ngIf="
                                  formHeader.get('fechaHasta').invalid &&
                                  (formHeader.get('fechaHasta').dirty ||
                                  formHeader.get('fechaHasta').touched)
                              ">
                            <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                                Ingrese fecha hasta
                            </mdb-error>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row filtros-body">
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <mdb-select label="Bancos origen" [options]="optionsBancoOri" [multiple]="true"
                            placeholder="Bancos origen" [filterEnabled]="true" formControlName="bancosOrigen">
                        </mdb-select>
                    </div>
                </div>
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <mdb-select label="Bancos destino" [options]="optionsBancoDes" [multiple]="true"
                            placeholder="Bancos destino" [filterEnabled]="true" formControlName="bancosDestino">
                        </mdb-select>
                    </div>
                </div>
                <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                        <input value="" type="text" id="nroCheque" class="form-control" placeholder="XXXXXXXXXX"
                            #nroCheque formControlName="nroDoc" onlyNumbers />
                        <label for="nroCheque">Nro. de cheque</label>
                    </div>
                </div>
            </div>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <div>
                <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
                    <mdb-icon fas icon="broom"></mdb-icon>
                    Limpiar
                </button>
                <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
                    <mdb-icon fas icon="search"></mdb-icon>
                    Buscar
                </button>
            </div>
        </div>
    </form>
</div>

<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div *ngIf="loading" class="w-100 d-block text-center">
        <mdb-spinner *ngIf="loading" spinnerColor="blue"></mdb-spinner>
      </div>
        <div class="table-responsive" *ngIf="listaCheques">

            <a mdbBtn color="info" class="waves-light" mdbWavesEffect *ngIf="listaCheques?.length === 0">
                No existen registros para los filtros seleccionado</a>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaCheques?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">Fecha Venc.</th>
                        <th scope="col">Fecha Ingr.</th>
                        <th scope="col">Fecha Dep.</th>
                        <th scope="col">Banco Origen</th>
                        <th scope="col">Nro Cheque</th>
                        <th scope="col">RUT</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Banco Destino</th>
                        <th scope="col">Nro. Depósito</th>
                        <th scope="col">Monto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cheque of listaCheques">
                        <td>{{cheque.fecha_vecimiento | fecha}}</td>
                        <td>{{cheque.fecha_ingreso | fecha}}</td>
                        <td>{{cheque.fecha_deposito | fecha}}</td>
                        <td>{{cheque.banco_nombre_origen}}</td>
                        <td>{{cheque.numero_doc}}</td>
                        <td>{{cheque.cliente_proveedor_rutFormato | rut}}</td>
                        <td>{{cheque.cliente_proveedor_nombre}}</td>
                        <td>
                            <mdb-badge pill="true" *ngIf="cheque.estado === 1" warning="true">{{cheque.estado_nombre}}
                            </mdb-badge>
                            <mdb-badge pill="true" *ngIf="cheque.estado === 2" success="true">{{cheque.estado_nombre}}
                            </mdb-badge>
                            <mdb-badge pill="true" *ngIf="cheque.estado === 3" danger="true" >{{cheque.estado_nombre}}
                            </mdb-badge><!-- protestado | rojo -->
                            <mdb-badge pill="true" *ngIf="cheque.estado === 4" primary="true">{{cheque.estado_nombre}}
                            </mdb-badge>
                            <mdb-badge pill="true" *ngIf="cheque.estado === 5" primary="true" >{{cheque.estado_nombre}}
                            </mdb-badge><!-- redeposito | morado -->
                            <mdb-badge pill="true" *ngIf="cheque.estado === 6" warning="true" >{{cheque.estado_nombre}}
                            </mdb-badge>
                            <mdb-badge pill="true" *ngIf="cheque.estado === 7" success="true" >{{cheque.estado_nombre}}
                            </mdb-badge>
                        </td>
                        <td>{{cheque.banco_nombre_destino}}</td>
                        <td>{{cheque.n_deposito}}</td>
                        <td>$ {{cheque.monto | numerico}}</td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaCheques?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaCheques?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
      <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
        Excel
      </button>
      <button mdbBtn type="button" color="success" mdbWavesEffect class="btn"  (click)="downloadPdf()">
        PDF
      </button>
    </div>
  </div>
